import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import { BranchSwicthSplashContextProvider } from "../../../provider/branch/branch_switch_splash/BranchSwicthSplashContextProvider";
import BranchSwitchSplashContent from "./BranchSwitchSplashContent";

const BranchSwitchSplashScreen = () => {
  return (
    <BranchSwicthSplashContextProvider>
      <Scaffold>
        <BranchSwitchSplashContent />
      </Scaffold>
    </BranchSwicthSplashContextProvider>
  );
};

export default BranchSwitchSplashScreen;
export const routeName: string = "/branch-switch-flash";
